// extracted by mini-css-extract-plugin
module.exports = {"hidden":"positionListPage_hidden__u5B0Y","textEmphasis":"positionListPage_textEmphasis__tlrQ4","positionListArea":"positionListPage_positionListArea__zERWk"};